export const getTitleContainerStyles = (hasDescription: boolean) => ({
	alignItems: 'center',
	justifyContent: 'center',
	paddingX: { xs: '1.25rem', md: '2%', lg: '5%', xl: '6rem' },
	textAlign: 'center',
	textWrap: 'pretty',
	maxWidth: { xs: '100%', sm: '100%', md: hasDescription ? '50%' : '100%' },
	margin: `0 auto`,
});

export const titleStyles = {
	paddingTop: { xs: '2.5rem', md: '3.75rem' },
	paddingBottom: { xs: '2.5rem', md: '.75rem' },
};

export const chipStyles = {
	color: 'secondary.main',
	borderColor: 'secondary.main',
	'&:hover': {
		color: 'secondary.main',
		backgroundColor: 'neutrals.white',
		opacity: 0.8,
	},
	'&.Mui-selected': {
		backgroundColor: 'secondary.main',
		color: 'neutrals.white',
		'&:hover': {
			color: 'neutrals.white',
			backgroundColor: 'secondary.main',
			opacity: 0.8,
		},
	},
};

export const filterListStyles = {
	display: 'flex',
	flexWrap: 'wrap',
	justifyContent: 'center',
	gap: '1rem',
	padding: '2rem 0',
};
